import { useAPI } from "@Light/services/api";
import { Button } from "@Light/components/page/Button";

export type LogoutButtonProps = {};

export const LogoutButton: React.FC<LogoutButtonProps> = ({}) => {
  const { useLogoutMutation } = useAPI();
  const [logout] = useLogoutMutation();
  return <Button onClick={() => logout()}>Log out</Button>;
};
